import { api } from '@/core/api/';

const URL = 'api/support/';

export const getQualityStadistics = () => api.get(`${URL}`);
export const updateSummariesByBill = (billId) =>
  api.post(`${URL}assistent/bill/${billId}`);
export const updateSummarieByBill = (contractRequest) =>
  api.post(`${URL}summary/update/`, contractRequest);
